import styled, { css } from 'styled-components';
import { SPACING_4 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';
import tabStyles from 'components/Tabs/styles';

const BREAKPOINT_7PLUS = '@media only screen and (min-width: 768px)'; // (Breakpoints 7 and above)

const HorizontalNavigation = styled.div`
  & [data-parent="ccfk-tab-close-icon-button"] {
    svg * {
      fill: ${({ $content }) => `${$content}`};
    }
    &:hover {
      background-color: ${({ $hoverfill }) => `${$hoverfill}`};
    }
  }
  ${tabStyles.TabWrapper} {
    border: 0;
    &:hover {
      ${tabStyles.TabCloseButton} {
        background-image: none;
      }
    }
  }
  ${tabStyles.Tabs} {
    border: 0;
    background-color: ${({ theme }) => `${theme.background}`};
  }
  ${tabStyles.TabsSelectedIndicator} {
    border-bottom: ${({ theme }) => `${theme.on.onIndicator} ${SPACING_4} solid`};
  }
  ${tabStyles.TabScrollButtonContainer} {
    button {
      svg * {
        fill: ${({ theme }) => `${theme.closeButton.content}`};
      }
      &:hover {
        background-color: ${({ theme }) => `${theme.closeButton.hover}`};
        svg * {
          fill: ${({ theme }) => `${theme.closeButton.hovered.content}`};
        }
      }
    }
  }
  ${tabStyles.TabNotificationBadge} {
    &:before {
      ${({ rtl }) => rtl && css`
        margin-right: 0;
        ${BREAKPOINT_7PLUS} {
          margin-right: 0.375rem;
        }
      `}
      ${({ rtl }) => !rtl && css`
        margin-left: 0;
        ${BREAKPOINT_7PLUS} {
          margin-left: 0.375rem;
        }
      `}
    }
  }
`;

const HorizontalNavigationLabel = styled.div`
  position: relative; 
  ${tabStyles.BUTTON_TYPOGRAPHY}
  color: ${({ theme }) => theme && theme.off && theme.off.content};
  text-align: center;
  transition: color ${tabStyles.TRANSITION_TIME} ${tabStyles.TRANSITION_BEZIER};
  white-space: normal;
  text-align: center;
  ${({ selected, $isPressed }) => selected && !$isPressed && css`
    color: ${({ theme }) => theme.on && theme.on.content}
  `};
  ${({ $isPressed }) => $isPressed && css`
    color: ${({ theme }) => theme && theme.on.pressedText};
  `}
  /* disabled */
  ${({ disabled }) => disabled && css`
    color: ${({ theme }) => theme.disabled && theme.disabled.content};
      cursor: default;
      &:hover {
        ${({ theme }) => theme.disabled && theme.disabled.content};
      }
  `}
`;

const styles = {
  HorizontalNavigation,
  HorizontalNavigationLabel,
};
export default styles;